/**
 * Helper: take an array and chunk it up
 * @param array the array to chunk
 * @param chunkSize the desired chunk size
 * @returns an array of chunked arrays
 */
export const chunkArray = <T>(array: Array<T>, chunkSize: number): Array<Array<T>> =>
  Array(Math.ceil(array.length / chunkSize))
    .fill(0)
    .map((_: T, index: number) => index * chunkSize)
    .map((begin: number) => array.slice(begin, begin + chunkSize))
